import ImmutableModel from '../immutable.model';

/**
 * A service gruop retrieved from the backend.
 */
class ServiceGroup extends ImmutableModel {

  /**
   * @param {Number} id
   * @param {String} name
   * @param {Number} order_number
   */
  constructor(
    id,
    name,
    order_number
  ) {
    super();

    this.id = id;
    this.name = name;
    this.order_number = order_number;
  }

  copy() {
    return new ServiceGroup(this.id, this.name, this.order_number);
  }
}

export default ServiceGroup;



// WEBPACK FOOTER //
// ./src/app/common/models/servicegroup.model.js